/* eslint-disable indent */
import SecureLS from 'secure-ls'
const ENC_KEY = process.env.VUE_APP_ENC_KEY
var ls = new SecureLS({ isCompression: false, encryptionSecret: ENC_KEY })
export const AUTH_URL = process.env.VUE_APP_AUTH_URL
export const AUTH_API_TOKEN = process.env.VUE_APP_UNOAPP_API_TOKEN
export const authToken = () => ls.get('vuex') ? JSON.parse(ls.get('vuex')).auth.user.token : ''
export const PRODUCT_URL = process.env.VUE_APP_PRODUCT_URL
export const PRODUCT_APP_ID = process.env.VUE_APP_PRODUCT_APP_ID
export const PRODUCT_APP_SECRET = process.env.VUE_APP_PRODUCT_APP_SECRET
export const LOCATION_URL = process.env.VUE_APP_LOCATION_URL
export const LOCATION_API_TOKEN = process.env.VUE_APP_LOCATION_API_TOKEN
